import { IconName } from '@fortawesome/fontawesome-svg-core';
import { OptionRowValue } from 'elements/minute/sidebar/sidebarComponents/atomic/OptionRowValue';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSection } from 'elements/minute/sidebar/sidebarSection/SidebarSection';
import { useContext } from 'react';
import { IDirectionWorldMarker, Transport } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { getTransportPath } from 'static/externalApi/directionApi';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IDirectionWorldMarker;
}

const TRANSPORT_OPTIONS: Array<{ transport: Transport; iconName: IconName }> = [
    {
        transport: 'driving',
        iconName: 'car' as const
    },
    {
        transport: 'cycling',
        iconName: 'person-biking' as const
    },
    {
        transport: 'walking',
        iconName: 'person-walking' as const
    }
];

export const MarkerTransportationSection = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    const { marker } = props;

    async function updateTransport(transport: Transport) {
        const { path, waypoints } = await getTransportPath(
            transport,
            marker?.elementData?.coordinates
        );
        ctxEdit.updateWorldMarkerData(marker.id, { transport, coordinates: waypoints, path });
    }

    return (
        <S_MarkerTransportationSection className={props.className}>
            <SidebarSection
                title={Localization.TRANSPORTATION}
                icon={{ iconName: 'route' }}
                topBorder
                disableBottomBorder={true}
            >
                <SidebarContent withTopPadding withHover>
                    <OptionRowValue
                        items={TRANSPORT_OPTIONS.map((e) => ({ iconName: e.iconName }))}
                        selectedIndex={TRANSPORT_OPTIONS.findIndex(
                            (e) => marker.elementData.transport === e.transport
                        )}
                        onSelected={(newIndex) => {
                            updateTransport(TRANSPORT_OPTIONS[newIndex].transport);
                        }}
                    />
                </SidebarContent>
            </SidebarSection>
        </S_MarkerTransportationSection>
    );
};

const S_MarkerTransportationSection = styled.div``;
